// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import ApprovalsServices from "../../services/externalServices/TicketServices/approvalsServices"


// const Approvals = () => {
//   const [approvals, setApprovals] = useState([]);
//   const [selectedApprovals, setSelectedApprovals] = useState([]);
//   const [status, setStatus] = useState(''); // For selected status (Approve, Reject, etc.)


//   const { firstname, lastname, role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));
//     const isTicketAdmin = role === 'ticket-admin';
//     const theatreName = accessList?.[0];

//   useEffect(() => {
//     fetchApprovals();
//   }, []);

//   // Fetching approvals with 'status: New'
//   const fetchApprovals = async () => {
//     try {
//       const res = await ApprovalsServices.getApproval();  // Assuming the service is correct

//       console.log('res of the approval get', res);
//       setApprovals(res);
//     } catch (err) {
//       console.error('Failed to fetch approvals', err);
//     }
//   };

//   // Handle individual checkbox toggle
//   const handleSelectChange = (id) => {
//     setSelectedApprovals((prevSelected) => {
//       if (prevSelected.includes(id)) {
//         return prevSelected.filter(item => item !== id); // Remove if already selected
//       } else {
//         return [...prevSelected, id]; // Add to selected
//       }
//     });
//   };

//   // Handle "Select All" checkbox toggle
//   const handleSelectAllChange = (e) => {
//     if (e.target.checked) {
//       const allIds = approvals.map(app => app._id);
//       setSelectedApprovals(allIds);
//     } else {
//       setSelectedApprovals([]);
//     }
//   };

//   // Handle status change for selected approvals
// //   const handleBatchUpdate = async () => {
// //     if (selectedApprovals.length === 0 || !status) {
// //       alert('Please select approvals and status.');
// //       return;
// //     }

// //     try {
// //       // Batch update selected approvals
// //      const response= await ApprovalsServices.updateApproval({
// //         ids: selectedApprovals,
// //         status,
// //         approved_by: firstname // Replace with the actual admin ID
// //       });

// //     //    // Batch update selected approvals
// //     // const response = await ApprovalsServices.updateApproval({
// //     //     ids: selectedApprovals,
// //     //     status,
// //     //     approved_by: 'admin_user' // Replace with actual admin ID (e.g., `firstname`)
// //     //   });

// //       console.log('response',response);

// //       // Fetch updated approvals after batch update
// //       fetchApprovals();
// //       setSelectedApprovals([]); // Clear selected approvals after updating
// //     } catch (err) {
// //       console.error('Failed to update status', err);
// //     }
// //   };

//   const handleBatchUpdate = async () => {
//     if (selectedApprovals.length === 0 || !status) {
//       alert('Please select approvals and status.');
//       return;
//     }

//     try {
//       // Batch update selected approvals
//       const response = await ApprovalsServices.updateApproval({
//         ids: selectedApprovals,
//         status,
//         approved_by: firstname // Replace with the actual admin ID
//       });

//       // Check if the response is successful
//       if (response ) {
//         // Success - show success alert
//         alert('Status updated successfully.');

//         // Fetch updated approvals after batch update
//         fetchApprovals();
//         setSelectedApprovals([]); // Clear selected approvals after updating
//       } else {
//         // If not successful, show an error alert
//         alert('Failed to update status. Please try again.');
//       }
//     } catch (err) {
//       console.error('Failed to update status', err);
//       alert('Failed to update status. Please try again.');
//     }
//   };


//   return (
//     <div>
//       <div>
//         <select onChange={(e) => setStatus(e.target.value)} defaultValue="">
//           <option value="" disabled>Select Status</option>
//           <option value="Approved">Approve</option>
//           <option value="Rejected">Reject</option>
//           <option value="Not Applicable">N/A</option>
//         </select>
//         <button onClick={handleBatchUpdate}>Update Selected</button>
//       </div>

//       <table>
//         <thead>
//           <tr>
//             <th>
//               <input
//                 type="checkbox"
//                 checked={selectedApprovals.length === approvals.length && approvals.length > 0}
//                 onChange={handleSelectAllChange}
//               />
//             </th>
//             <th>Phone</th>
//             <th>Employee</th>
//             <th>Township</th>
//             <th>Comments</th>
//           </tr>
//         </thead>
//         <tbody>
//           {approvals.map((app) => (
//             <tr key={app._id}>
//               <td>
//                 <input
//                   type="checkbox"
//                   checked={selectedApprovals.includes(app._id)}
//                   onChange={() => handleSelectChange(app._id)}
//                 />
//               </td>
//               <td>{app.phone_number}</td>
//               <td>{app.employee_name}</td>
//               <td>{app.township_id}</td>
//               <td>{app.comments}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default Approvals;











import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ApprovalsServices from "../../services/externalServices/TicketServices/approvalsServices"
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const Approvals = () => {
  const navigate = useNavigate(); // ✅ CORRECT location
  const [approvals, setApprovals] = useState([]);
  const [selectedApprovals, setSelectedApprovals] = useState([]);
  const [status, setStatus] = useState("Approved");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  //   const navigate = useNavigate();





  // Pagination state (add these)
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(100); // Items per page


  // Calculate pagination values (add this before return)
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = approvals.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(approvals.length / itemsPerPage);




  const { firstname, lastname, role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));
  const isTicketAdmin = role === 'ticket-admin';
  const theatreName = accessList?.[0];

  useEffect(() => {
    fetchApprovals();
  }, []);

  const fetchApprovals = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const isTicketAdmin = role === 'ticket-admin';
      const payload = isTicketAdmin ? { theatreName } : {};

      const res = await ApprovalsServices.getApproval(payload);
      // const res = await ApprovalsServices.getApproval({ theatreName: theatreName });
      setApprovals(res);
    } catch (err) {
      console.error('Failed to fetch approvals', err);
      setError('Failed to load approvals. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleApprove = () => {
    navigate('/approveList')
  };

  const handleSelectChange = (id) => {
    setSelectedApprovals((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter(item => item !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      const allIds = approvals.map(app => app._id);
      setSelectedApprovals(allIds);
    } else {
      setSelectedApprovals([]);
    }
  };

  const handleBatchUpdate = async () => {
    if (selectedApprovals.length === 0 || !status) {
      alert('Please select approvals and status.');
      return;
    }

    try {
      setIsLoading(true);
      const response = await ApprovalsServices.updateApproval({
        ids: selectedApprovals,
        status,
        approved_by: firstname
      });

      if (response) {
        alert('Status updated successfully.');
        fetchApprovals();
        setSelectedApprovals([]);
      } else {
        alert('Failed to update status. Please try again.');
      }
    } catch (err) {
      console.error('Failed to update status', err);
      alert('Failed to update status. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Approval Requests</h1>

        {/* Control Panel */}
        <div className="bg-white rounded-lg shadow-md p-4 mb-6">
          <div className="flex flex-wrap items-center gap-4">
            <div className="flex-1 min-w-[200px]">
              <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1">
                Action
              </label>
              <select
                id="status"
                onChange={(e) => setStatus(e.target.value)}
                defaultValue="Approved"
                className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border"
              >
                {/* <option value="" disabled>Select Action</option> */}
                <option value="Approved">Approve</option>
                <option value="Rejected">Reject</option>
                <option value="Not Applicable">Mark as N/A</option>
              </select>
            </div>

            <button
              onClick={handleBatchUpdate}
              disabled={selectedApprovals.length === 0 || !status || isLoading}
              className={`px-4 py-2 rounded-md text-white font-medium mt-6 ${selectedApprovals.length === 0 || !status || isLoading
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-blue-600 hover:bg-blue-700'
                }`}
            >
              {isLoading ? 'Processing...' : 'Update Selected'}
            </button>

            <button
              onClick={fetchApprovals}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md font-medium hover:bg-gray-300 mt-6"
            >
              Refresh
            </button>

            <button
              onClick={handleApprove}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md font-medium hover:bg-gray-300 mt-6"
            >
              ApprovedList
            </button>
          </div>
        </div>

        {/* Approval Table */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          {isLoading ? (
            <div className="p-8 text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
              <p className="mt-4 text-gray-600">Loading approvals...</p>
            </div>
          ) : error ? (
            <div className="p-8 text-center text-red-500">{error}</div>
          ) : approvals.length === 0 ? (
            <div className="p-8 text-center text-gray-500">No approval requests found</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      <input
                        type="checkbox"
                        checked={selectedApprovals.length === approvals.length && approvals.length > 0}
                        onChange={handleSelectAllChange}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      #
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      EmployeeName
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      PhoneNo
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      EmployeeNo
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      HouseNo
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Township
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Comments
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {currentItems.map((app, index) => (
                    <tr key={app._id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <input
                          type="checkbox"
                          checked={selectedApprovals.includes(app._id)}
                          onChange={() => handleSelectChange(app._id)}
                          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {indexOfFirstItem + index + 1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {app?.employee_name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {app?.phone_number}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {app?.employee_id}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {app?.house_no}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {app?.township_details?.full_name}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500 max-w-xs truncate">
                        {app?.comments}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Add the pagination footer */}
        <div className="flex justify-between items-center px-6 py-3 bg-gray-50 border-t border-gray-200">
          <div className="text-sm text-gray-600">
            Total: {approvals.length} approvals | Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, approvals.length)} of {approvals.length}
          </div>
          <div className="flex space-x-2">
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={`px-4 py-2 rounded-md ${currentPage === 1 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
            >
              Previous
            </button>
            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className={`px-4 py-2 rounded-md ${currentPage === totalPages ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
            >
              Next
            </button>
          </div>
        </div>

        {/* Selected count indicator */}
        {selectedApprovals.length > 0 && (
          <div className="mt-4 text-sm text-gray-600">
            {selectedApprovals.length} {selectedApprovals.length === 1 ? 'item' : 'items'} selected
          </div>
        )}
      </div>
    </div>
  );
};

export default Approvals;
